// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#MazPhoneNumberInput-41_country_selector,#MazPhoneNumberInput-41_phone_number,.country-selector__input,.input-tel__input{min-height:51px!important}", ""]);
// Exports
module.exports = exports;
